<template>
  <div class="">
    <line-chart :chart-data="datacollection" :options="option"></line-chart>
  </div>
</template>

<script>
import PieChart from './PieChart.js'
import LineChart from './LineChart.js'

export default {
    components: {
      PieChart,
      LineChart
    },
    data () {
      return {
        datacollection: {
          labels: null,
          datasets: []
        },
        secondCollection: null,
        option: null,
        actualPeriod: null,
        pastPeriod: null,
        range: null,
        actualPeriodColor: '#5ecfa1',
        pastPeriodColor: '#d8dbee',
        field: 'tot'
      }
    },
    mounted () {
      this.fillData()

    },
    methods: {

      fillData (data) {
        let self = this;
        let actualData = null;
        let pastData = null;
        let labelData = null;

        if(data){
          labelData = data.labels || null;
          actualData = data.actual || null;
          pastData = data.past || null;
        }
        this.option = {
          maintainAspectRatio: false,
          offsetGridLines: true,
          layout: {
              padding: {
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0
              }
          },
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'EUR',
              },
              stacked: false,
              gridLines: {
                display: true
              },
              ticks: {
                callback: function(value) {
                  if(value === 0) return value;
                  return self.$options.filters.formatPriceExt(value, null, 0);
                }
              }
            }],
            xAxes: [{
              stacked: true,
              gridLines: {
                display: true
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                let name = data.datasets[tooltipItem.datasetIndex].label;
                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                value = self.$options.filters.formatPriceExt(value, self.$store.getters.getCustomer.currency_label)
                return name+": "+value;
              }
            }
          }
        }

        this.datacollection = {
          labels: labelData,
          datasets: []
        }

        this.actualPeriod = {
          label: this.$t("Current period"),
          borderColor: this.actualPeriodColor,
          backgroundColor: 'rgba(0, 0, 0, 0)',
          pointStyle: 'rect',
          pointBorderWidth: 3,
          data: []
        };
        if(actualData){
          actualData.forEach(element => {
            //this.datacollection.labels.push(element.day);
            if(this.field=='tot')
              this.actualPeriod.data.push(element.tot);
            else if(this.field=='avg')
              this.actualPeriod.data.push(element.avg);
          });
        }
        this.datacollection.datasets.push(this.actualPeriod)

        if(pastData){
          this.pastPeriod = {
            label: this.$t("Previous period"),
            borderColor: this.pastPeriodColor,
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointStyle: 'rect',
            pointBorderWidth: 3,
            data: []
          };
          if(pastData){
            pastData.forEach(element => {
              //this.datacollection.labels.push(element.day);
            if(this.field=='tot')
              this.pastPeriod.data.push(element.tot);
            else if(this.field=='avg')
              this.pastPeriod.data.push(element.avg);
            });
          }
          this.datacollection.datasets.push(this.pastPeriod)
        }
      },
      dataRefact(data){

      }
    }
  }
</script>
<style lang="scss">
  .btn.btn-secondary{
    background-color: #f8f6f9;
    border-color: #f8f6f9;
    color: black;
    &:hover{
      color: white;
      background-color: #60616275;
      border-color: #60616275;
    }
  }
  #line-chart.chartjs-render-monitor{
    min-height: 400px;
  }
</style>
